import $ from 'jquery';
import ads from '../services/admanager';

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
            return pair[1];
        }
    }
}

var videoLanding = function (pageNumberFromParam) {

    const $moreVideos = $('.more-videos');
    const $videoSetTwo = $('.video-set-two');
    const $videoProgram = $('.video-program');

    // Add a class to make the next set of results landing page results visible
    $moreVideos.click(function () {
        $($videoSetTwo).addClass('visible');
        $(this).hide();
    });

    // On program pages, give each set of 10 a page number
    if (document.location.href.indexOf('/program/') !== -1) {
        var pageNumber = getQueryVariable('page');
        if (!pageNumber) {
            pageNumber = 1;
        }

        // Pass in the page number
        if (pageNumberFromParam) {
            pageNumber = pageNumberFromParam;
        }

        // Get this program's identifier
        if (window.bootstrap_id) {
            var programId = window.bootstrap_id.split('|')[2];

            if ($videoProgram.data('lastpage') === pageNumber) {
                $($moreVideos).hide();
            }

            // Click "See More" to load next page of results for this program
            $moreVideos.click(function () {
                $('.more-content').last().load(`/videos/program/${programId}?page=${++pageNumber} .video-program`, function () {
                    videoLanding(pageNumber);
                    $('.more-content').find('.poster').lazyLoadXT();
                    ads();
                });
            });
        }
    }

};

export default videoLanding;
